var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfileUser = function SvgProfileUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 34"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17 0C7.612 0 0 7.611 0 17s7.611 17 17 17c9.39 0 17-7.611 17-17S26.39 0 17 0m0 5.083a5.623 5.623 0 1 1 0 11.247 5.623 5.623 0 0 1 0-11.247M8.872 26.56a12.48 12.48 0 0 0 8.124 2.996c3.1 0 5.937-1.128 8.125-2.996a2.39 2.39 0 0 0 .84-1.82c0-3.15-2.538-5.67-5.689-5.67H13.73c-3.15 0-5.698 2.52-5.698 5.67 0 .699.308 1.366.84 1.82",
    clipRule: "evenodd"
  })));
};
export default SvgProfileUser;